module.exports = __webpack_public_path__ + "static/media/tab-back.95cdeb10.png";